import React from 'react';

import {Drawer} from 'presentation/components/Drawer';
import {translations} from 'presentation/translations-new';
import {DistanceFilter} from './components/DistanceFilter';
import {OdontoFilter} from './components/OdontoFilter';
import {UnitsFilterDrawerProps} from './types';
import {GeolocationFilter} from './components/GeolocationFilter';

const {filter} = translations['pt-br'].commons;

export function UnitsFilterDrawer({
	openDrawerState,
	handleOpenDrawer,
	handleCloseDrawer,
	showDistanceDrawer,
	showOdontoDrawer,
	showGeolocationFilterDrawer,
	flowType,
	distanceFilterAtMaxDistance,
	handleConfirmDistance,
	handleClearDistance,
	districtGeolocationState,
	setDistrictGeolocationState,
	selectedFilterGeolocationState,
	setSelectedFilterGeolocationState,
	servingPeopleWithDisabilities,
	handleClearDisability,
	handleConfirmDisability,
}: UnitsFilterDrawerProps) {
	return (
		<Drawer.Root
			open={openDrawerState}
			onOpen={handleOpenDrawer}
			width="685px"
			customMaxHeight={'100%'}
			onClose={() => handleCloseDrawer(true)}
			sx={{zIndex: 9000}}>
			<Drawer.Header title={filter} onClose={() => handleCloseDrawer(true)} />

			{showDistanceDrawer ? (
				<DistanceFilter
					openDrawerState={openDrawerState}
					distanceFilterAtMaxDistance={distanceFilterAtMaxDistance}
					handleClearDistance={handleClearDistance}
					handleConfirmDistance={handleConfirmDistance}
				/>
			) : null}

			{showOdontoDrawer ? (
				<OdontoFilter
					servingPeopleWithDisabilities={servingPeopleWithDisabilities!}
					handleClearDisability={handleClearDisability!}
					handleConfirmDisability={handleConfirmDisability!}
				/>
			) : null}

			{showGeolocationFilterDrawer ? (
				<GeolocationFilter
					openDrawerState={openDrawerState}
					distanceFilterAtMaxDistance={distanceFilterAtMaxDistance}
					handleCloseDrawer={handleCloseDrawer}
					handleConfirmDistance={handleConfirmDistance}
					handleClearDistance={handleClearDistance}
					districtGeolocationState={districtGeolocationState!}
					setDistrictGeolocationState={setDistrictGeolocationState!}
					selectedFilterGeolocationState={selectedFilterGeolocationState!}
					setSelectedFilterGeolocationState={setSelectedFilterGeolocationState!}
					flowType={flowType!}
					servingPeopleWithDisabilities={servingPeopleWithDisabilities}
					handleClearDisability={handleClearDisability}
					handleConfirmDisability={handleConfirmDisability}
				/>
			) : null}
		</Drawer.Root>
	);
}
